const headers = {
  name: "Products",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Import/Export",
        path: "/app/importexport",
      },
      {
        name: "Products",
        path: "",
      },
    ],
    total: [],
  },
};

export default headers;
